import { MainTemplate } from './MainTemplate';

export * from './MainTemplate';
export default MainTemplate;
